import { FC, useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';

interface IProps {
  methods: any;
  data: any;
  onSubmit: (data: any) => void;
}

interface IDataType {
  [key: string]: string | number | boolean;
}

const ReportForm: FC<IProps> = ({ methods, data, onSubmit }) => {
  const { t } = useTranslation();
  const [employees, setEmployees] = useState(data?.user || []);

  useEffect(() => {
    // Set default status to active employees
    methods.setValue(
      'status',
      data?.status.filter((j: IDataType) => j.selected)
    );
  }, [data, methods]);

  const groups = methods.watch('group_id');

  useEffect(() => {
    const groupIds = groups?.map((gr: any) => gr.value);

    if (groupIds) {
      const filteredEmployees = data?.user.filter((empl: any) => {
        if (!empl.groups.length) return groupIds.includes('null');

        const isInSelectedGroups = empl.groups.reduce((flag: boolean, currGr: number) => {
          return flag || groupIds.includes(currGr);
        }, false);
        return isInSelectedGroups;
      });

      setEmployees(filteredEmployees);
      methods.setValue('user_id', filteredEmployees);
    } else {
      setEmployees(data?.user);
      methods.setValue('user_id', null);
    }
  }, [groups, data?.user, methods]);

  return (
    <Form
      methods={methods}
      btnLabel={t('reports.downloadEmployeeDataReport')}
      hideCancelBtn
      onSubmit={onSubmit}
    >
      <Row>
        <Col md={4}>
          <FormGroup
            controlId="formGroupGroups"
            label={t('reports.groups')}
            type="select"
            as="select"
            name="group_id"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            selectOptions={data?.group}
          />
        </Col>
        <Col md={4}>
          <FormGroup
            controlId="formGroupEmployees"
            label={t('reports.employees')}
            type="select"
            as="select"
            name="user_id"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            showTotal
            selectOptions={employees}
            limitOptions
          />
        </Col>
        <Col md={4}>
          <FormGroup
            controlId="formGroupStatus"
            label={t('reports.employeeStatus')}
            type="select"
            as="select"
            name="status"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            selectOptions={data?.status}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ReportForm;
